import _ from "lodash";

export function isToday(str:string|null){
    if(!str)
        return false;

    const date = new Date(str);
    return date.toDateString() === new Date().toDateString();
}

export const getTimeString = (time?: string | null) => {
    const [h, m] = _.split(time, ":").map(i => parseInt(i));
    
    if (_.isNil(h) || _.isNil(m)) {
      return "";
    }
  
    const date = new Date()
    date.setHours(h);
    date.setMinutes(m);
  
    const fmt = Intl.DateTimeFormat("default", {hour: 'numeric', minute: 'numeric'});
    return fmt.format(date).toUpperCase();
  }
